import { fetchAuthSession, AuthUser as CognitoUser } from "aws-amplify/auth";
import { createContext, useContext, useEffect, useState } from "react";

type AuthUser = {
  username: string;
  roles: string[];
};

type AuthState =
  | { state: "PENDING" }
  | { state: "AUTHENTICATED"; user: AuthUser; signOut: () => void };

export const AuthContext = createContext<AuthState>({ state: "PENDING" });

export const useAuthContext = () => useContext<AuthState>(AuthContext);

interface AuthContextProviderProps {
  cognitoUser: CognitoUser;
  signOut: () => void;
  children: any;
}

export const AuthContextProvider = (props: AuthContextProviderProps) => {
  const [user, setUser] = useState<AuthState>({
    state: "PENDING",
  });

  useEffect(() => {
    const setUpUser = async () => {
      const session = await fetchAuthSession();
      console.log("Session:", session);
      const groups = session.tokens?.idToken?.payload["cognito:groups"];
      if (groups) {
        setUser({
          state: "AUTHENTICATED",
          user: {
            username: props.cognitoUser.signInDetails?.loginId ?? "",
            roles: groups as string[],
          },
          signOut: props.signOut,
        });
      } else {
        setUser({
          state: "AUTHENTICATED",
          user: {
            username: props.cognitoUser.signInDetails?.loginId ?? "",
            roles: [],
          },
          signOut: props.signOut,
        });
      }
    };
    setUpUser();
  }, []);

  return (
    <AuthContext.Provider value={user}>{props.children}</AuthContext.Provider>
  );
};

export type { AuthState, AuthUser };
